import { Box, Divider, Typography } from "@mui/material"
import dayjs from "dayjs"
import type { FC } from "react"

import { getProductTestStatusLabel } from "../../utils"

import { DATE_FORMAT } from "@/constants/formats"
import type { ProductTestStatus } from "@/graphql/codegen/graphql"
import type { ProductTestWithDocuments } from "@/screens/Products/components/Product/Quality/TestResults/types"

interface ProductTestCoaInfoProps {
  productTest: ProductTestWithDocuments
  currentOrderId?: string | null
}

export const ProductTestCoaInfo: FC<ProductTestCoaInfoProps> = ({ productTest, currentOrderId }) => {
  const manufacturingDate = productTest.manufacturingDate
    ? dayjs(productTest.manufacturingDate).format(DATE_FORMAT.US)
    : "-"
  const expirationDate = productTest.expirationDate ? dayjs(productTest.expirationDate).format(DATE_FORMAT.US) : "-"
  const status = productTest.status ? getProductTestStatusLabel(productTest.status as ProductTestStatus) : "-"

  return (
    <Box className='text-gray-700'>
      <Typography className='font-medium tracking-[0.2px] text-gray-700'>COA Information</Typography>
      <Divider className='mb-6 mt-1' />
      <Typography variant='body2' component='div' className='grid grid-cols-3 gap-y-4'>
        <Box>
          <Box className='font-bold'>Lot #</Box>
          <Box data-testid='lot-number-display'>{productTest.lotNumber || "-"}</Box>
        </Box>
        <Box>
          <Box className='font-bold'>Batch #</Box>
          <Box data-testid='batch-number-display'>{productTest.batchNumber || "-"}</Box>
        </Box>
        <Box>
          <Box className='font-bold'>Purchase Order #</Box>
          <Box data-testid='po-number-display'>{currentOrderId || "-"}</Box>
        </Box>
        <Box>
          <Box className='font-bold'>Manufacturing Date</Box>
          <Box data-testid='manufacturing-date-display'>{manufacturingDate}</Box>
        </Box>
        <Box>
          <Box className='font-bold'>Expiration Date</Box>
          <Box data-testid='expiration-date-display'>{expirationDate}</Box>
        </Box>
        <Box>
          <Box className='font-bold'>Status</Box>
          <Box data-testid='status-display'>{status}</Box>
        </Box>
      </Typography>
    </Box>
  )
}
